// extracted by mini-css-extract-plugin
export default {"deploymentPage":"JobPage_deploymentPage__f793d","forwardArea":"JobPage_forwardArea__F3ppy"};